document.addEventListener('DOMContentLoaded', function () {
  if (!document.querySelector('.banner-panel')) {
    document.body.classList.add('no-banner-panel');
  }
});
// ===========================FAQs TAB==================================================
document.addEventListener('DOMContentLoaded', function () {
  const tabButtons = document.querySelectorAll('.faq-tab-button');
  const tabContents = document.querySelectorAll('.faq-tab-content');
  // 👉 Set first tab active
  if (tabButtons.length > 0 && tabContents.length > 0) {
    tabButtons[0].classList.add('active');
    tabContents[0].classList.add('active');
    // 👉 Set first FAQ item inside first tab active
    const firstFaqItem = tabContents[0].querySelector('.faq-item');
    if (firstFaqItem) {
      firstFaqItem.classList.add('active');
    }
  }
  // 👉 Tab switching
  tabButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabContents.forEach(content => content.classList.remove('active'));

      this.classList.add('active');
      document.getElementById(this.dataset.tab).classList.add('active');
      // 👉 Activate first FAQ item in the newly opened tab
      const activeTabContent = document.getElementById(this.dataset.tab);
      const firstFaqInTab = activeTabContent.querySelector('.faq-item');
      if (firstFaqInTab) {
        firstFaqInTab.classList.add('active');
      }
    });
  });
  // 👉 FAQ toggle
  document.querySelectorAll('.faq-question').forEach(function(question) {
    question.addEventListener('click', function() {
      this.parentElement.classList.toggle('active');
    });
  });
});



// ===========================GIFT CART CHECK BOX==================================================
  document.addEventListener('DOMContentLoaded', function () {
    const checkbox = document.getElementById('send-gift-card');
    const fields = document.querySelector('.gift-card-fields');

    if (!checkbox || !fields) return;

    checkbox.addEventListener('change', function () {
      fields.style.display = this.checked ? 'block' : 'none';
    });
  });


// ===========================Ingredients Popup==================================================
  document.addEventListener('DOMContentLoaded', function () {
    const openBtn = document.querySelector('.ingredients-pop-btn');
    const popup = document.querySelector('.product-key-ingredients-popup');
    const closeBtn = document.querySelector('.ingredients-popup-close');

    if (!openBtn || !popup || !closeBtn) return;

    openBtn.addEventListener('click', function () {
      popup.classList.add('active');
    });

    closeBtn.addEventListener('click', function () {
      popup.classList.remove('active');
    });
  });


  document.addEventListener("DOMContentLoaded", function () {
  const quantity = document.querySelector('.product .product-form__quantity');
  const buyNowBtn = document.querySelector('.product .prd-buynow-btn');

  if (quantity && buyNowBtn) {
    const wrapper = document.createElement('div');
    wrapper.className = 'quantity_cartBtn_wrp';

    quantity.parentNode.insertBefore(wrapper, quantity);

    wrapper.appendChild(quantity);
    wrapper.appendChild(buyNowBtn);
  }
});


document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href="#book"]');
    if (!link) return;

    e.preventDefault(); // stop jump to top
    document.querySelector('.book-appointment-popup-section')?.classList.add('active');
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    const closeBtn = e.target.closest('.book-appointment-popup-close');
    if (!closeBtn) return;

    document.querySelector('.book-appointment-popup-section')?.classList.remove('active');
  });
});